import React from 'react';

interface VideoSectionProps {
  onNavigate: (page: string) => void;
}

const VideoSection: React.FC<VideoSectionProps> = ({ onNavigate }) => {
  return (
    <section className="relative h-[60vh] w-full overflow-hidden flex items-center justify-center my-12">
      {/* Fallback image if video fails to load or for mobile optimization */}
      <div className="absolute inset-0 bg-stone-900">
         <img 
            src="https://images.unsplash.com/photo-1629224316810-9d8805b95e76?q=80&w=2070&auto=format&fit=crop"
            className="w-full h-full object-cover opacity-50"
            alt="Jewelry making"
         />
      </div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-10"></div>

      <div className="relative z-20 text-center px-6">
        <h2 className="text-shimmer font-serif text-3xl md:text-5xl mb-6">
           The Art of Brilliance
        </h2>
        <p className="text-gray-300 max-w-2xl mx-auto font-light leading-relaxed mb-8">
          Every gemstone is selected for its exceptional clarity and color. Our master artisans handcraft each setting, ensuring that your piece is as unique as the moment it celebrates.
        </p>
        <button 
          onClick={() => onNavigate('shop')}
          className="px-6 py-3 border border-gold-500 text-gold-400 hover:bg-gold-500 hover:text-white transition-all duration-300 text-xs tracking-widest uppercase"
        >
          Discover Our Atelier
        </button>
      </div>
    </section>
  );
};

export default VideoSection;